import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuick from './components/CategoryQuick';
import FeaturedGrid from './components/FeaturedGrid';
import NewsSection from './components/NewsSection';
import SpecialSection from './components/SpecialSection';
import { media, news, specials } from '@/utils/data';

const HERO_IDS = ['m1', 't1', 'm7', 'm5', 'm3'];

export default function Home() {
  const heroItems = HERO_IDS.map((id) => media.find((item) => item.id === id)).filter(
    (item): item is (typeof media)[number] => Boolean(item),
  );

  return (
    <>
      <HeroCarousel items={heroItems} />
      <CategoryQuick />
      <FeaturedGrid items={media} />
      <NewsSection items={news} />
      <SpecialSection items={specials} />

      <section className="w-full px-4 md:px-8 pb-16 md:pb-20">
        <div className="rounded-lg border border-background-200/70 bg-gradient-to-br from-primary-900/60 via-background-100 to-background-100 p-6 md:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            <div className="lg:col-span-2">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                关于御宅屋
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
                御宅屋是一个专注于影视娱乐资讯聚合的内容平台。我们把最新电影、电视剧资讯、深度影评与观影攻略汇聚在一起，帮助你用更少的时间，找到真正值得一看的好作品。在这里，你可以浏览影片推荐、查看影视详情、收藏心仪片单，与千万影迷一起追剧看电影。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/category/movie"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-movie-2-line"></i>
                  浏览电影频道
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300/70 text-foreground-800 text-sm hover:border-accent-500/60 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-3 lg:grid-cols-1 gap-3">
              {[
                { value: `${media.length}+`, label: '影视作品库' },
                { value: `${news.length} 篇`, label: '影视资讯' },
                { value: `${specials.length} 个`, label: '精选专题' },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg bg-background-50/70 border border-background-200/70 p-4 text-center lg:text-left"
                >
                  <p className="font-heading text-xl md:text-2xl font-bold text-accent-400">
                    {stat.value}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}